export const DELIVERY_CART_MESSAGE = 'Check final delivery date in cart.';

export const ALERT_TYPES = {
  REMOVED: 'removed',
  ADDED: 'added',
  SWAPPED: 'swapped',
  SWAPPED_VARIANT: 'swapped-variant'
};

export const ALERT_CONFIGS = {
  [ALERT_TYPES.REMOVED]: {
    status: 'success',
    messageMain: 'Item removed from bundle.',
    messageSecondary: DELIVERY_CART_MESSAGE,
    showLink: false
  },
  [ALERT_TYPES.ADDED]: {
    status: 'success',
    messageMain: 'Item successfully added.',
    messageSecondary: DELIVERY_CART_MESSAGE,
    showLink: false
  },
  [ALERT_TYPES.SWAPPED]: {
    status: 'success',
    messageMain: 'Your item has been swapped.',
    messageSecondary: DELIVERY_CART_MESSAGE,
    showLink: true,
    linkText: 'Swap Back'
  }
};